module.exports = __webpack_public_path__ + "img/l16.29ae3224.png";